<div class="container">
  <div #scrollableContainer class="top">
    @if(!openActivity){
      <div class="card-input-wrapper">
        <input
          class="card-input"
          placeholder="Click to create a new activity"
          (focus)="expandEditor()"
        />
        <mat-icon class="add-icon">add</mat-icon>
      </div>
    }@else{
      <div class="new-activity">
        <app-event-confirmation-dialog (activityClosed)="expandEditor()" [hideRightPaneCalendar]="isModal()" [inputData]="{ hourSegments: this.hourSegments, detailed: true, hideCalendarProps: true, isExternal: true, defaultLead: leadId, leadView: true, editMode: false, hideNavigation: true}"></app-event-confirmation-dialog>
      </div>
    }
  </div>
  
  @if(activities && activities.length > 0){
    <div class="activity-list">
      @for(record of activities; track record.id){
        <app-card-item 
          [data]="record" 
          (click)="openActivityModal(record)"
          (editAction)="editActivity($event)" 
          (deleteAction)="deleteActivity($event)" 
          (markCompletedAction)="markCompleted($event)"
          style="cursor: pointer;">
        </app-card-item>
      }
    </div>
    
    <div style="text-align: center;cursor: pointer;" *ngIf="showLoad">
      <mat-icon (click)="moreData()">cached</mat-icon>
    </div>
  }@else if(!openActivity){
    <!-- Empty state only when no activities AND not creating/editing -->
    <div class="image-big">
      <img class="img" src="../../../../../assets/images/backgrounds/no-activity.png">
    </div>
  }
</div>